import type BaseError from './BaseError';

type TFieldValidationError = {
  code: 'FIELD_VALIDATION_ERROR';
  payload: {
    code: string;
    message: string;
    path: string;
    property: string;
  };
};
export default class ModelValidationError implements BaseError {
  private readonly payload: TFieldValidationError[];

  constructor(payload: TFieldValidationError[]) {
    this.payload = payload;
  }

  get message() {
    if (this.payload.length > 1) {
      return `There were ${this.payload.length} validation errors`;
    } else if (this.payload.length === 1) {
      return 'There was 1 validation error';
    }
    return 'Validation error';
  }
}
